import { create } from 'zustand'

const previewItemInitialState = {
    base64Data: '',
    documentName: '',
    documentType: '',
    mimeType: '',
    id: '',
    fileSize: 0,
    documentId: '',
    actor: '',
    back: false
}

const initialState = {
    preview: { ...previewItemInitialState, back: false },
    backSidePreview: { ...previewItemInitialState, back: true },
    editPreview: previewItemInitialState,
    isDialogOpen: false,
    isSidesPreview: false,
    isLoading: false,
    loadingProgress: 0,
    isEditPreview: false
}

export const useDocPreviewStore = create((set, get) => ({
    ...initialState,
    clearPreview: () =>
        set(({ preview }) => ({ preview: { ...preview, base64Data: previewItemInitialState.base64Data } })),
    clearBackSidePreview: () =>
        set(({ backSidePreview }) => ({
            backSidePreview: { ...backSidePreview, base64Data: previewItemInitialState.base64Data }
        })),
    clearEditPreview: () =>
        set(({ editPreview }) => ({
            editPreview: { ...editPreview, base64Data: previewItemInitialState.base64Data },
            isEditPreview: false
        })),
    setIsSidesPreview: (isSidesPreview) => set({ isSidesPreview }),
    setPreview: (preview) => set({ preview }),
    setBackSidePreview: (preview) => set({ backSidePreview: preview }),
    setEditPreview: (preview) => set({ editPreview: preview, isEditPreview: true }),
    toggleIsDialogOpen: () =>
        set(({ isDialogOpen }) => ({
            isDialogOpen: !isDialogOpen
        })),
    closeDialog: () => get().resetDocPreviewStore(),
    setIsLoading: (isLoading) => set({ isLoading }),
    setLoadingProgress: (loadingProgress) => set({ loadingProgress }),
    resetDocPreviewStore: () => set(initialState)
}))
